import { cva, cx } from '@lastbrand/web-ui-styled-system/css'
import React from 'react'

import Link from '@src/quince-components/src/atoms/link'

import { SiblingProductOptionType } from './sibling-product-options-ds'

const optionRecipe = cva({
  base: {
    textStyle: 'body-14',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    minWidth: '50px',
    paddingBlock: 'space-8',
    paddingInline: 'space-10',
    borderRadius: 'radius-none',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'rgba(33, 32, 31, 0.2)', // black @20%; no alpha token available
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 400,
    cursor: 'pointer',
  },
  variants: {
    selected: {
      true: {
        backgroundColor: 'black',
        borderColor: 'black',
        color: 'white',
      },
    },
  },
})

interface SiblingProductButtonDSProps {
  value: string
  displayName: string
  isActive: boolean
  variant: SiblingProductOptionType
  onClickCallback?: (val: string) => void
  className?: string
  id?: string
  testId?: string
}

// The in-place variant uses a plain `<button>` styled purely by Panda; the legacy
// rem-based `Button` atom inflates ~1.6x under the DS static 16px root.
function SiblingProductButtonDS({
  variant,
  value,
  displayName,
  isActive,
  onClickCallback,
  className,
  id,
  testId,
}: SiblingProductButtonDSProps) {
  // Single filled `selected` style: new-pdp-design-v2 concluded to groupB (filled), so the legacy
  // outlined-selected branch is dropped — the surviving variant, not a missed style.
  const optionClassName = cx(optionRecipe({ selected: isActive }), className)
  return variant === SiblingProductOptionType.LINK ? (
    <Link
      id={id}
      href={value}
      onClick={onClickCallback}
      // eslint-disable-next-line i18next/no-literal-string -- ARIA token, not user copy
      aria-current={isActive ? 'page' : undefined}
      className={optionClassName}
    >
      {displayName || value}
    </Link>
  ) : (
    <button
      id={id}
      data-testid={testId ?? id}
      type="button"
      aria-pressed={isActive}
      className={optionClassName}
      onClick={() => {
        !isActive && onClickCallback?.(value)
      }}
    >
      {displayName || value}
    </button>
  )
}

export default SiblingProductButtonDS
